var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 34,
    r: 2,
    fill: "#005AA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59174 35.2648L3.94008 34.8936H3.94008L4.59174 35.2648ZM43.4083 35.2648L42.7566 35.6361L43.4083 35.2648ZM28.064 8.33184L28.7157 7.96057L28.064 8.33184ZM19.936 8.33184L20.5876 8.70311L19.936 8.33184ZM24.7499 17.9999C24.7499 17.5857 24.4141 17.2499 23.9999 17.2499C23.5857 17.2499 23.2499 17.5857 23.2499 17.9999H24.7499ZM23.2499 27.9999C23.2499 28.4142 23.5857 28.7499 23.9999 28.7499C24.4141 28.7499 24.7499 28.4142 24.7499 27.9999H23.2499ZM27.4124 8.7031L42.7566 35.6361L44.0599 34.8936L28.7157 7.96057L27.4124 8.7031ZM39.3442 41.25H8.65577V42.75H39.3442V41.25ZM5.2434 35.6361L20.5876 8.70311L19.2843 7.96058L3.94008 34.8936L5.2434 35.6361ZM8.65577 41.25C5.65347 41.25 3.82285 38.1295 5.2434 35.6361L3.94008 34.8936C1.91757 38.4436 4.56837 42.75 8.65577 42.75V41.25ZM42.7566 35.6361C44.1772 38.1295 42.3465 41.25 39.3442 41.25V42.75C43.4316 42.75 46.0824 38.4436 44.0599 34.8936L42.7566 35.6361ZM28.7157 7.96057C26.6567 4.34647 21.3433 4.34648 19.2843 7.96058L20.5876 8.70311C22.0713 6.09897 25.9287 6.09896 27.4124 8.7031L28.7157 7.96057ZM23.2499 17.9999V27.9999H24.7499V17.9999H23.2499Z",
    fill: "#005AA9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b93d8bb6.svg";
export { ForwardRef as ReactComponent };